// Billing & subscription API
import { api, qs } from "./client";

// Public — the landing page pricing section calls this while signed out.
// `country` (#105) is opt-in: an authenticated caller who knows their own
// company's country can pass it to see the SAME per-country price checkout
// would actually charge; omitted, this is unchanged (base INR list price).
export const listPlans = (country) => api.get(`/billing/plans${qs({ country })}`);
export const getSubscription = () => api.get("/billing/subscription");
export const getUsage = () => api.get("/billing/usage");
export const createOrder = (plan_id, coupon_code, billing_period = "monthly") =>
  api.post("/billing/create-order", { plan_id, coupon_code: coupon_code || null, billing_period });
export const validateCoupon = (plan_id, coupon_code, billing_period = "monthly") =>
  api.post("/billing/validate-coupon", { plan_id, coupon_code, billing_period });
export const verifyPayment = (data) => api.post("/billing/verify-payment", data);
export const simulatePayment = (order_id, plan_id) => api.post("/billing/simulate-payment", { order_id, plan_id });
export const cancelSubscription = () => api.post("/billing/cancel", {});
export const listInvoices = () => api.get("/billing/invoices");
export const contactSales = (message) => api.post("/billing/contact-sales", { message });
